import React from 'react';
import { UserProfileDetails } from '../components/core/UserProfile';

export const UserProfile = () => {
    return <UserProfileDetails />;
}